module.exports = __webpack_public_path__ + "img/plus-circle.5094fff7.svg";